export default function EcologySection() {
  const nodes = [
    { name: '战略引擎', desc: '方向校准', color: '#FF6B35' },
    { name: '基础能力', desc: '认知执行', color: '#00D4FF' },
    { name: '品牌营销', desc: '客户增长', color: '#A855F7' },
    { name: '渔业领域', desc: '生产落地', color: '#10B981' },
  ];

  return (
    <section className="px-6 md:px-12 py-24 max-w-7xl mx-auto">
      <div className="rounded-[32px] bg-white/5 border border-white/10 p-8 md:p-10 text-center overflow-hidden relative">
        <div className="absolute inset-x-12 top-1/2 h-px bg-gradient-to-r from-transparent via-[#00D4FF]/30 to-transparent hidden md:block" />

        <div className="text-sm tracking-[0.35em] text-[#00D4FF] mb-4">
          DETERMINISTIC AGRICULTURE ECOLOGY
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
          确定性农业生态协同图
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 relative z-10">
          {nodes.map((node) => (
            <div
              key={node.name}
              className="rounded-3xl border px-5 py-6 text-white shadow-[0_0_28px_rgba(0,255,213,0.08)]"
              style={{
                backgroundColor: `${node.color}10`,
                borderColor: `${node.color}30`,
              }}
            >
              <div className="text-lg font-bold mb-1" style={{ color: node.color }}>
                {node.name}
              </div>
              <div className="text-xs text-white/50">{node.desc}</div>
            </div>
          ))}
        </div>

        <p className="text-white/65 text-base md:text-lg leading-8 max-w-4xl mx-auto">
          战略引擎负责方向校准，基础能力负责认知与执行，品牌营销负责客户增长，渔业领域负责生产落地，四层产品共同构成陆渔科技面向未来农业的智能操作系统。
        </p>
      </div>
    </section>
  );
}